"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANGOPAY_SCA_EXPIRE_TIME = void 0;
const time_1 = require("./time");
exports.MANGOPAY_SCA_EXPIRE_TIME = 10 * time_1.MINUTE_IN_MILLISECONDS;
//# sourceMappingURL=mangopay.js.map